export const taxIdNumberFormatStrategy = (value: string) => {
  return !!value.match('[0-9]{8}');
};
